<template>
    <el-form ref="form" label-position="top">
        <el-row :gutter="25">
            <el-col :md="12">
                <el-form-item class="el-form-item-full" v-if="$p('settings/dynamicDns/address')" :label="$l('settings/dynamicDns/Address')">
                    <el-input :disabled="getSettingsAddons.dns == '0'" v-model="getSettingsDynamicDNS.host"></el-input>
                </el-form-item>
            </el-col>
            <el-col v-if="$p('settings/dynamicDns/provider')" v-show="getSettingsAddons.dns == '1'" :md="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/dynamicDns/Provider')">
                    <el-select v-model="getSettingsDynamicDNS.provider" :placeholder="$l('common/select')">
                        <el-option label="Dyn DNS" value="dyndns"></el-option>
                        <el-option label="NO-IP" value="noip"></el-option>
                        <el-option label="Dynu" value="dynu"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col v-if="$p('settings/dynamicDns/username')" v-show="getSettingsAddons.dns == '1'" :md="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/dynamicDns/Username')">
                    <el-input v-model="getSettingsDynamicDNS.user"></el-input>
                </el-form-item>
            </el-col>
            <el-col v-if="$p('settings/dynamicDns/password')" v-show="getSettingsAddons.dns == '1'" :md="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/dynamicDns/Password')">
                    <el-input :type="showPassword?'':'password'"  v-model="getSettingsDynamicDNS.password">
                        <el-button @click="showPassword=!showPassword" class="show-password-button" slot="append"><icon name="eye"> </icon></el-button>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col  v-if="$p('settings/dynamicDns/ip')" :md="12">
                <el-form-item class="el-form-item-full" :label="$l('settings/dynamicDns/IP')">
                    <el-input :disabled="getSettingsAddons.dns == '0'" v-model="getSettingsDynamicDNS.ip"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
    
</template>

<style>
    .show-password-button{
        padding: 0px;
        padding-left: 2px;
        padding-right: 2px;
        padding-top: 2px;
        width:30px;
    }
</style>

<script>
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
            showPassword: false
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsDynamicDNS',
            'getSettingsAddons'
        ])
    },
    methods: {
        onSubmit() {
            console.log('submit!');
        }
    }
}
</script>


// WEBPACK FOOTER //
// DynamicDns.vue?705fcee2